export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8309.505ef298.jpg";